import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  titleNavigation: <PortalMessage id='t.app.disputeUci.title.navigation' defaultMessage='Dispute' />,
  labelButtonLeftNav: <PortalMessage id='t.app.back' defaultMessage='Indietro' />,
  labelMenu: <PortalMessage id='t.app.support' defaultMessage='Assistenza' />,
  disputeUciTitle: (
    <PortalMessage
      id='t.app.disputeUci.title'
      defaultMessage='Seleziona gli stabilimenti e visualizzane le pratiche.'
    />
  ),
  selectedShopLabel: <PortalMessage id='t.app.disputeUci.selectedShop.label' defaultMessage='Stabilimenti selezionati' />,
  selectedShopEditLabel: <PortalMessage id='t.app.disputeUci.selectedShop.editLabel' defaultMessage='Modifica' />,
  shopCode: <PortalMessage id='t.app.disputeUci.shop.code' defaultMessage='Codice stabilimento:' />,
  selectedShopOf: <PortalMessage id='t.app.disputeUci.selectedShop.of' defaultMessage='di' />,

  multipleSelectedShopLabel: (selectedShopsNumber, shopTotalNumber) => (
    <PortalMessage
      id='t.app.disputeUci.selectedShop.multiple'
      defaultMessage='<b>{selectedShopsNumber}</b> di <b>{shopTotalNumber}</b> selezionati'
      values={{ selectedShopsNumber, shopTotalNumber }}
    />
  ),

  // Messages
  timeoutModalTitle: (
    <PortalMessage
      id='t.app.disputeUci.timeoutModal.title'
      defaultMessage='Il caricamento potrebbe richiedere più tempo del previsto'
    />
  ),
  timeoutModalDescription: (
    <PortalMessage
      id='t.app.disputeUci.timeoutModal.description'
      defaultMessage='Per migliorare le performance, riduci il numero di stabilimenti selezionati. In alternativa, attendi il completamento dell’operazione.'
    />
  ),
  timeoutModalPrimaryButtonLabel: (
    <PortalMessage
      id='t.app.disputeUci.timeoutModal.primaryButtonLabel'
      defaultMessage='Seleziona stabilimenti'
    />
  ),
  disputeListDownloaded: <PortalMessage id='t.app.disputeUci.downloadListSuccess' defaultMessage='La lista delle pratiche presenti in pagina è stata scaricata con successo.' />,
  downloadDocumentPractice: (name) => (
    <PortalMessage
      id='t.app.disputeBox.download.success.document'
      defaultMessage='Il documento <b>{name}</b> è stato scaricato con successo.'
      values={{ name }}
    />
  )
}

export default formattedMessage
